import { render, staticRenderFns } from "./LayoutLogin.vue?vue&type=template&id=4dbbf89e&scoped=true&"
import script from "./LayoutLogin.vue?vue&type=script&lang=js&"
export * from "./LayoutLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbbf89e",
  null
  
)

export default component.exports